// 不需要 label 的组件
export const advancedComponents = {
  divider: '分割线',
  hidden: '隐藏域',
  button: '按钮',
}
